// External library imports
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const IconTextContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const ComplianceLinkContainer = styled.div`
    margin: 1rem 0;
    width: 100%;
    background: #d3d3d3;
    border-radius: 2px;
    display: flex;
    align-items: stretch;
    justify-content: center;
    box-sizing: border-box;
    padding: 0.5rem;
`;

export const ContainerBox = styled.div`
    padding: 0.5rem 1.5rem;
    width: 100%;
    box-sizing: border-box;
`;

export const useStyles = makeStyles({
    iconWrapper: {
        marginTop: '0.5rem',
        marginRight: '0.5rem'
    },
    textWrapper: {
        marginTop: '0.5rem',
        wordWrap: 'break-word',
        flex: 1,
        minWidth: 0
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start'
    }
});
